export default [
  {
    path: '/external/cheque',
    name: 'ChequeQueue',
    component: () => import('@/views/external/cheque-queue'),
    meta: {
      keepAlive: false,
      bg_white: true
    }
  },
  {
    path: '/external/bank',
    name: 'BankTransfer',
    component: () => import('@/views/external/bank-transfer'),
    meta: {
      keepAlive: false,
      bg_white: true
    }
  },
]